export const cardLinkNeutralDark = '#4B5563'
export const cardLinkNeutralDarkest = '#262B32'
export const cardLinkNeutralMedium = '#B7BBC1'
export const cardLinkPrimaryColor = '#A800FF'
export const cardLinkPrimaryLightColor = '#F6E6FF'
export const cardLinkSuccess = '#157F1F'
export const cardLinkSuccessLight = '#D4FFD9'
export const cardLinkError = '#D64045'
export const cardLinkErrorLight = '#FFC8CA'

export const gradientTextStyles = {
    background: `-webkit-linear-gradient(83.53deg, #A800FF 18.47%, #2C73FF 78%)`,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    fontWeight: 700,
}
